const $ = window.jQuery;
const Lazyembed = require('./lazyembed.js');
module.exports = {
  initialize: function (options) {
    let that = this;
    this.$ = function (selector) {
      return jQuery(selector, options.el)
    }
    this.$postsContainer = this.$('[data-lm-container]');
    this.$trigger = this.$('[data-lmp-trigger]');
    this.$emptySearch = this.$('[data-empty-search]');
    this.reqData = this.$trigger.data();
    this.$selectedTopicEl = null;
    this.$selectedTopicParentEl = null;
    this.selectedTopic = null;
    this.selectedParentTopic = null;
    this.$selectedTypeEl = null;
    this.selectedType = null;
    this.selectedYear = null;
    this.selectedMonth = null;
    this.searchterm = (this.reqData.searchterm) ? this.reqData.searchterm : '';
    jQuery('[data-remove-term]').on('click', function () {
      jQuery(this).parent().find('input').val('');
      that.searchterm = '';
      that.getPosts(true);
    });

    if (!this.reqData.hasMore) {
      this.$trigger.hide();
    }


    jQuery('[data-filter-topic]').on('click', (e) => {
      this.selectTopic(e);
    })
    jQuery('[data-filter-type]').on('click', (e) => {
      this.selectType(e);
    })
    jQuery('[data-lmp-trigger]').on('click', (e) => {
      this.loadMore(e);
    })
    jQuery('[data-filter-date]').on('click', (e) => {
      this.selectDate(e);
    })
    jQuery('[data-filter-month]').on('click', (e) => {
      this.selectMonth(e);
    })
    jQuery('[data-filter-topic-select]').on('click', (e) => {
      this.selectTopicSelect(e);
    })
  },
  events: {
    'click [data-filter-topic]': 'selectTopic',
    'click [data-filter-type]': 'selectType',
    'click [data-lmp-trigger]': 'loadMore',
    'change [data-filter-date]': 'selectDate',
    'change [data-filter-topic-select]': 'selectTopicSelect',
  },
  selectDate: function (e) {
    let val = e.currentTarget.value;
    this.selectedYear = val;
    this.getPosts(true);
  },
  selectMonth: function (e) {
    let val = e.currentTarget.value;
    this.selectedMonth = val;
    this.getPosts(true);
  },
  selectTopicSelect: function (e) {
    let val = e.currentTarget.value;
    this.selectedTopic = val;
    this.getPosts(true);
  },
  selectTopic: function (e) {
    let $el = $(e.currentTarget);
    let isParent = (typeof $el.data('parent') !== 'undefined');
    let isChild = ($el.data('parent-term') === this.selectedParentTopic);
    let topic = $el.data('filterTopic');

    if (isParent) {
      if (this.selectedTopic && this.selectedTopic === topic) {
        this.$selectedTopicParentEl.removeClass('active');
        this.selectedTopic = '';
        this.selectedParentTopic = '';
        this.$selectedTopicEl = null;
        this.$selectedTopicParentEl = null;
        $el.next('ul').slideUp();
        this.getPosts(true);
        return;
      }
    }

    if (this.selectedTopic && this.selectedTopic === topic) {
      return;
    }

    $el.next('ul').slideDown();


    if (isParent) {
      this.selectedParentTopic = $el.data('parent');
      if (this.$selectedTopicParentEl) {
        this.$selectedTopicParentEl.removeClass('active');
      }
      this.$selectedTopicParentEl = $el;
      this.$selectedTopicParentEl.addClass('active');
    }

    // if (!isParent && isChild) {
    if (this.$selectedTopicEl) {
      this.$selectedTopicEl.removeClass('active');
    }

    this.$selectedTopicEl = $el;
    this.$selectedTopicEl.addClass('active')
    // }


    this.selectedTopic = $el.data('filterTopic');
    this.getPosts(true);
  },
  selectType: function (e) {
    let $el = $(e.currentTarget);
    let val = $el.data('filterType');

    if (val === this.selectedType) {
      val = '';
      this.$selectedTypeEl.removeClass('active');
      this.$selectedTypeEl = null;

    } else {
      if (this.$selectedTypeEl && this.$selectedTypeEl !== $el) {
        this.$selectedTypeEl.removeClass('active');
      }
      this.$selectedTypeEl = $el;
      this.$selectedTypeEl.addClass('active')
    }

    this.selectedType = val;
    this.getPosts(true);
  },
  loadMore: async function () {
    this.$postsContainer.addClass('loading');
    this.$trigger.addClass('loading');
    const url = window.tpdata.base_url + this.reqData.ep;
    let data = Object.assign({}, this.reqData, {
      articletopictax: this.selectedTopic,
      date: this.selectedYear,
      offset: this.reqData.offset,
      kdType: this.selectedType,
      searchterm: this.searchterm,
      ppp: 6,
    });

    const req = await $.ajax(url, {
      data: data
    });
    this.$postsContainer.removeClass('loading');
    this.$trigger.removeClass('loading');
    this.$postsContainer.append(req.out);
    this.reqData.offset = this.reqData.offset + req.length;
    setTimeout(function () {
      Lazyembed.initialize({trigger: true});
    }, 5)
    if (req.postsLeft) {
      this.$trigger.show();
    } else {
      this.$trigger.hide();
    }
  },
  async getPosts(replace = false) {

    this.$postsContainer.addClass('loading');
    this.$trigger.addClass('loading');
    this.$emptySearch.hide();

    const url = window.tpdata.base_url + this.reqData.ep;
    let data = Object.assign({}, this.reqData, {
      articletopictax: this.selectedTopic,
      date: this.selectedYear,
      month: this.selectedMonth,
      offset: 0,
      kdType: this.selectedType,
      searchterm: this.searchterm
    })

    this.reqData = data;

    const req = await $.ajax(url, {
      data: data
    });
    if (replace) {
      this.$postsContainer.empty().append(req.out)
      this.reqData.offset = req.length;
    } else {
      this.$postsContainer.append(req.out);
      this.reqData.offset = this.reqData.offset + req.length;
    }

    if (req.length === 0){
      this.$emptySearch.show();
    }

    setTimeout(function () {
      Lazyembed.initialize({trigger: true});
    }, 5)
    this.$postsContainer.removeClass('loading');
    this.$trigger.removeClass('loading');
    if (req.postsLeft) {
      this.$trigger.show();
    } else {
      this.$trigger.hide();
    }

  }
};
